<template>
    <div v-if="isFormLoaded">
        <rkm-alert
            v-if="additionals.oci"
            color="info"
        >
            Esta solicitação faz parte do protocolo/oci <strong>{{ additionals.oci }}</strong> ativado com data de validade até {{ additionals.validadeOci }}.
        </rkm-alert>

        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-area
                title="Dados do paciente"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            disabled
                            label="Nome"
                            required
                            v-model="form.paciente.nome"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            disabled
                            label="Nome social"
                            v-model="form.paciente.nomeSocial"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            disabled
                            label="Data de nascimento"
                            required
                            v-model="form.paciente.dataNascimento"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            disabled
                            label="Nome da mãe"
                            required
                            v-model="form.paciente.nomeMae"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            disabled
                            label="Prontuário municipal"
                            required
                            v-model="form.paciente.prontuario"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            disabled
                            label="Sexo"
                            required
                            v-model="form.paciente.sexo"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-input
                            disabled
                            label="Raça/cor"
                            required
                            v-model="form.paciente.racaCor"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            disabled
                            label="Nº CNS"
                            required
                            v-model="form.paciente.cns"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            disabled
                            label="CPF"
                            required
                            v-model="form.paciente.cpf"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            disabled
                            label="RG"
                            required
                            v-model="form.paciente.rg"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            :disabled="pesoApi || checkIsVisualizacao"
                            @input="handlePesoInput"
                            label="Peso"
                            placeholder="000.00"
                            v-mask="masks.peso"
                            v-model="model.peso"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    kg
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            :disabled="alturaApi || checkIsVisualizacao"
                            label="Altura"
                            placeholder="000"
                            v-mask="masks.altura"
                            v-model="model.altura"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    cm
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>
                </rkm-row>

                <rkm-area
                    title="Identificação de saúde"
                    tipe="fieldset"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input
                                disabled
                                label="Unidade de referência"
                                v-model="form.paciente.unidadeReferencia"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                disabled
                                label="Profissional responsável"
                                v-model="form.paciente.usuarioResponsavel"
                            />
                        </rkm-col>

                        <rkm-col cols="2" v-if="additionals.exibeProtocoloCross">
                            <rkm-form-input
                                :disabled="checkIsVisualizacao"
                                :validations="validations.protocoloCross"
                                label="Prontuário estadual (CROSS)"
                                v-model="form.paciente.protocoloCross"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area title="Telefones">
                    <rkm-row>
                        <rkm-col>
                            <Telefones
                                :telefones="form.paciente.telefones"
                                class="telefones"
                                readonly
                                ref="telefones"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area title="Endereço">
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input
                                class="endereco"
                                disabled
                                v-model="form.paciente.endereco"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-row>
                    <rkm-col class="text-right">
                        <rkm-button
                            :disabled="checkIsVisualizacao"
                            :label="false"
                            @click.stop="$refs.ModalPacienteCadastroSimplificado.open(pacienteId)"
                            color="primary"
                        >
                            Atualizar cadastro
                        </rkm-button>
                    </rkm-col>
                </rkm-row>

                <ModalPacienteCadastroSimplificado
                    @save="reloadPaciente($event)"
                    ref="ModalPacienteCadastroSimplificado"
                />

                <ModalHistoricoAtendimentoAmbulatorio
                    ref="ModalHistoricoAtendimentoAmbulatorio"
                />
            </rkm-area>

            <rkm-area
                title="Dados da solicitacao"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-date-picker
                            :disabled="!additionals.solicitacaoRetroativa || isDisabled"
                            :maxDate="dataSolicitacaoAtual"
                            :validations="validations.dataSolicitacao"
                            label="Data da solicitação"
                            v-model="formattedDataAtual"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="!additionals.sempreAlterarUnidadeSolicitante && (!additionals.isRegulador || isDisabled)"
                            :options="form.unidadesSolicitantes"
                            :validations="validations.unidadeSolicitanteId"
                            label="Unidade Solicitante"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeSolicitanteId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="!additionals.isRegulador || isDisabled"
                            :options="form.infraestruturasSolicitantes"
                            :validations="validations.infraestruturaSolicitanteId"
                            label="Local de atendimento (solicitante)"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaSolicitanteId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :disabled="checkIsVisualizacao"
                            :repository="repositories.usuario"
                            :searchFields="fields.autocomplete.usuarioSolicitante"
                            :requestQueryStringParams="{
                                registro_estado_id: additionals.usuarioRegistroEstadoId || null,
                            }"
                            :text-field="u => `${u.cidadaoNome}`"
                            :validations="validations.usuarioSolicitante"
                            @select="handleProfissionalSolicitanteChange"
                            label="Profissional solicitante"
                            placeholder="Digite o nome do profissional"
                            uppercase
                            v-model="model.usuarioSolicitante"
                            value="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="checkIsVisualizacao"
                            :options="form.prioridades"
                            :validations="validations.prioridadeId"
                            label="Prioridade"
                            show-default-option
                            text-field="nome"
                            v-model="model.prioridadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :disabled="model.ciap !== null || isCiapRequired || checkIsVisualizacao"
                            :repository="repositories.cid"
                            :requestQueryStringParams="autocompleteRequestParams.cid"
                            :searchFields="fields.autocomplete.cid"
                            :text-field="c => `${formatCid(c.codigo)} - ${c.nome}`"
                            :validations="validations.cid"
                            @input="model.ciap = null"
                            label="CID"
                            placeholder="Digite o código ou o nome do CID"
                            uppercase
                            v-model="model.cid"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :disabled="model.cid !== null || checkIsVisualizacao"
                            :repository="repositories.ciap"
                            :requestQueryStringParams="autocompleteRequestParams.ciap"
                            :searchFields="fields.autocomplete.ciap"
                            :text-field="c => `${c.codigo} - ${c.descricao}`"
                            :validations="validations.ciap"
                            @input="model.cid = null"
                            label="CIAP"
                            placeholder="Digite o código ou o nome do CIAP"
                            uppercase
                            v-model="model.ciap"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-date-picker
                            :disabled="checkIsVisualizacao"
                            :min-date="additionals.dataAtual"
                            :validations="validations.dataDesejada"
                            label="Data desejada"
                            v-model="formattedDataDesejada"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="this.procedimento.length > 0 || isDisabled || checkIsVisualizacao"
                            :options="form.unidadesReguladoras"
                            :validations="validations.unidadeReguladoraId"
                            label="Unidade reguladora"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeReguladoraId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="this.procedimento.length > 0 || isDisabled || checkIsVisualizacao"
                            :options="form.reguladores"
                            :validations="validations.reguladorId"
                            label="Local de atendimento (regulador)"
                            show-default-option
                            text-field="nome"
                            v-model="model.reguladorId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <div v-if="model.usuarioSolicitante && form.infoProfissional.unidades && form.infoProfissional.unidades.length > 0">
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="checkIsVisualizacao"
                                :options="form.infoProfissional.unidades"
                                :validations="validations.unidadeUsuarioId"
                                label="Unidade do profissional solicitante"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.infoProfissional.unidadeUsuarioId"
                                value-field="id"
                                @change="handleUnidadeUsuarioSolitante"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="checkIsVisualizacao"
                                :options="form.infoProfissional.infraestruturas"
                                :validations="validations.infraestruturaUsuarioId"
                                label="Local de atendimento do profissional solicitante"
                                show-default-option
                                text-field="nome"
                                v-model="model.infoProfissional.infraestruturaUsuarioId"
                                value-field="id"
                                @change="handleInfraestruturaUsuarioSolitante"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="checkIsVisualizacao"
                                :options="form.infoProfissional.ocupacoes"
                                :validations="validations.ocupacaoUsuarioId"
                                label="CBO do profissional solicitante"
                                show-default-option
                                text-field="nome"
                                v-model="model.infoProfissional.ocupacaoUsuarioId"
                                value-field="id"
                                @change="handleOcupacaoUsuarioSolitante"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="checkIsVisualizacao"
                                :options="form.infoProfissional.especialidades"
                                label="Especialidade do profissional solicitante"
                                show-default-option
                                text-field="nome"
                                v-model="model.infoProfissional.usuarioSolicitanteEspecialidadeId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>
                </div>

                <div>
                    <rkm-row>
                        <rkm-col class="text-right">
                            <rkm-button
                                v-if="isEdicao && model.soapId && hasPermissao('show-ambulatorio-historico-atendimento')"
                                :disabled="checkIsVisualizacao"
                                :label="false"
                                @click.stop="$refs.ModalHistoricoAtendimentoAmbulatorio.open(model.dadosAtendimento.data.form)"
                                color="primary"
                            >
                                Visualizar histórico de atendimento
                            </rkm-button>

                            <rkm-button
                                :disabled="checkIsVisualizacao || checkHabilitaArquivo()"
                                :label="false"
                                @click.stop="$refs.ModalImportaArquivo.open(form.paciente, model, additionals)"
                                :color="colorButtonArquivos"
                                ref="buttonArquivos"
                            >
                                Arquivos
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>

                    <ModalImportaArquivo
                        ref="ModalImportaArquivo"
                        :uploads="uploads"
                    />
                </div>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            :disabled="checkIsVisualizacao"
                            :validations="validations.hipoteseDiagnosticaJustificativa"
                            label="Hipótese Diagnóstica / Justificativa"
                            maxlength="5000"
                            uppercase
                            v-model="model.hipoteseDiagnosticaJustificativa"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            :disabled="checkIsVisualizacao"
                            :validations="validations.observacao"
                            label="Observações"
                            maxlength="5000"
                            uppercase
                            v-model="model.observacao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-area title="Exames/Procedimentos/Especialidades">
                    <rkm-row>
                        <rkm-col>
                            <rkm-button
                                :disabled="checkBottonExame || isVisualizacao"
                                :label="false"
                                @click.stop="$refs.ModalExame.open()"
                                class="buttons"
                                color="primary"
                            >
                                Exames
                            </rkm-button>

                            <ModalExame
                                :exames="this.procedimento"
                                :infraestruturaSolicitanteId="model.infraestruturaSolicitanteId || isVisualizacao"
                                :isEdicao="this.isEdicao"
                                :reguladorId="model.reguladorId || ''"
                                :pacienteId="pacienteId"
                                :sexoPaciente="this.sexoPacienteId"
                                :solicitacoesItens="model.solicitacoesItens"
                                @addExame="addExame"
                                ref="ModalExame"
                            />

                            <rkm-button
                                :disabled="checkBottonProcedimentoCirurgico || isVisualizacao"
                                :label="false"
                                @click.stop="$refs.ModalProcedimentoCirurgico.open()"
                                class="buttons"
                                color="primary"
                            >
                                Procedimentos cirúrgicos
                            </rkm-button>

                            <ModalProcedimentoCirurgico
                                :infraestruturaSolicitanteId="model.infraestruturaSolicitanteId || isVisualizacao"
                                :isEdicao="this.isEdicao"
                                :procedimentos="this.procedimento"
                                :reguladorId="model.reguladorId || ''"
                                :sexoPaciente="this.sexoPacienteId"
                                @addProcedimento="addProcedimento"
                                ref="ModalProcedimentoCirurgico"
                            />

                            <rkm-button
                                :disabled="checkBottonEspecialidade || isVisualizacao"
                                :label="false"
                                @click.stop="$refs.ModalEspecialidade.open()"
                                class="buttons"
                                color="primary"
                            >
                                Especialidades
                            </rkm-button>

                            <ModalEspecialidade
                                :especialidades="this.procedimento"
                                :infraestruturaSolicitanteId="model.infraestruturaSolicitanteId || isVisualizacao"
                                :isEdicao="this.isEdicao"
                                :reguladorId="model.reguladorId || ''"
                                :sexoPaciente="this.sexoPacienteId"
                                @addEspecialidade="addEspecialidade"
                                ref="ModalEspecialidade"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-table
                        :fields="fields.procedimento"
                        :items="procedimento"
                        class="table-procedimento"
                        sort-by=""
                        sort-desc
                    >
                        <template v-slot:cell(itens)="{ item }">
                            <div
                                v-for="procedimento in item.procedimento"
                                :key="procedimento"
                            >
                                {{ procedimento }}
                            </div>
                        </template>

                        <template v-slot:cell(actions)="{ item }">
                            <rkm-button
                                :disabled="(isDisabled && !item.novo) || checkIsVisualizacao"
                                @click="destroy(item)"
                                color="danger"
                                small
                                title="Excluir"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>
                        </template>
                    </rkm-table>

                    <Supervisor
                        @authorized="authorized"
                        @canceled="canceled"
                        ref="ModalSupervisor"
                    />
                </rkm-area>

                <rkm-area
                    v-if="!!id"
                    title="Histórico de movimentações"
                >
                    <template slot="trailing">
                        <rkm-button
                            @click="printHistoricoMovimentacoes"
                            color="info"
                            small
                        >
                            <rkm-icon icon="print" />
                        </rkm-button>
                    </template>

                    <rkm-table
                        :items="form.historicoMovimentacoes.status"
                        :fields="fields.historicoMovimentacoesStatus"
                        hide-filters
                        sort-by="dataHoraMovimentacao"
                        sort-desc
                    >
                        <template v-slot:cell(justificativaStatus)="{ item }">
                            <rkm-button
                                :id="uniqueId(`justificativa-status-${item.solicitacaoHistoricoId}`)"
                                small
                            >
                                <rkm-icon icon="comment" />
                            </rkm-button>

                            <rkm-popover
                                :target="uniqueId(`justificativa-status-${item.solicitacaoHistoricoId}`)"
                                placement="top"
                                triggers="hover"
                            >
                                {{ item.justificativaStatus }}
                            </rkm-popover>
                        </template>
                    </rkm-table>
                </rkm-area>
            </rkm-area>
        </rkm-form>
    </div>
</template>
<script>

// Components.
import ModalEspecialidade from '@/components/regulacao/solicitacao/components/especialidade/Modal'
import ModalExame from '@/components/regulacao/solicitacao/components/exame/Modal'
import ModalPacienteCadastroSimplificado from '@/components/cadastro/paciente/components/cadastro-simplificado/Modal'
import ModalProcedimentoCirurgico from '@/components/regulacao/solicitacao/components/procedimento-cirurgico/Modal'
import Telefones from '@/components/cadastro/cidadao/Telefone'
import Supervisor from '@/components/regulacao/solicitacao/components/supervisor/Modal'
import ModalHistoricoAtendimentoAmbulatorio from '@/components/regulacao/solicitacao/components/historico-atendimento-ambulatorio/Modal'
import ModalImportaArquivo from '@/components/regulacao/solicitacao/components/importa-arquivo/Modal'

// Enums
import origem from '@/enums/regulacao/origem'
import racaCor from '@/enums/cadastro/cidadao/racaCor'
import sexo from '@/enums/cadastro/cidadao/sexo'
import tipoRegistro from '@/enums/cadastro/usuario/tipoRegistro'
import classificacaoPaciente from '@/enums/cadastro/paciente/classificacao'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error, formats, file, permissao } from '@/mixins'

// Libraries.
import moment from 'moment'

// Filters.
import filters from '@/filters/formats'

export default {
    components: {
        ModalEspecialidade,
        ModalExame,
        ModalPacienteCadastroSimplificado,
        ModalProcedimentoCirurgico,
        Telefones,
        Supervisor,
        ModalHistoricoAtendimentoAmbulatorio,
        ModalImportaArquivo,
    },
    computed: {
        isDisabled() {
            return this.isEdicao;
        },
        formattedDataAtual: {
            get() {

                if (!this.additionals.dataAtual) {

                    return null;
                }

                if (this.model.data) {

                    const [day, month, year] = this.model.data.split('/');
                    return `${year}-${month}-${day}`;
                }

                const [day, month, year] = this.additionals.dataAtual.split('/');
                return `${year}-${month}-${day}`;
            },
            set(newValue) {

                if (newValue) {

                    const year = newValue.getFullYear();
                    const month = String(newValue.getMonth() + 1).padStart(2, '0');
                    const day = String(newValue.getDate()).padStart(2, '0');

                    this.model.data = `${day}/${month}/${year}`;
                    this.$set(this.additionals, 'dataAtual', `${day}/${month}/${year}`);
                }
            }
        },
        formattedDataDesejada: {
            get() {

                if (!this.model.dataDesejada) {

                    return null;
                }
                const [day, month, year] = this.model.dataDesejada.split('/');
                return `${year}-${month}-${day}`;
            },
            set(newValue) {

                if (newValue) {

                    const year = newValue.getFullYear();
                    const month = String(newValue.getMonth() + 1).padStart(2, '0');
                    const day = String(newValue.getDate()).padStart(2, '0');

                    this.model.dataDesejada = `${day}/${month}/${year}`;
                }
            }
        },
        autocompleteRequestParams() {

            const sexo = this.form?.paciente?.sexo;

            const sexoId = this.form?.paciente?.sexo_id;
            return {
                cid: {
                    sexo: sexo
                    ? this.form.paciente.sexoId == this.enums.sexo.MASCULINO ? 'M' : 'F'
                    : null,
                },
                ciap: {
                    sexo_id: sexoId,
                    show_all: true
                },
            }
        },
        isFormLoaded() {

            return this.isDataLoaded;
        },
        validations() {

            const isCiap = this.model.usuarioSolicitante?.registroTipoId === this.enums.tipoRegistro.COREN;
            const dataDesejada = this.additionals.isDataDesejadaRequired ? true :  false;

            let ciapRequired = false;
            let cidRequired = true;

            if (isCiap) {

                ciapRequired = true;
                cidRequired = false;
            } else {

                ciapRequired = false;
                cidRequired = true;
            }

            return {
                ciap: { required: ciapRequired },
                cid: { required: cidRequired },
                dataDesejada: { required: dataDesejada },
                hipoteseDiagnosticaJustificativa: { required: true, max: 5000 },
                infraestruturaSolicitanteId: { required: true },
                observacao: { max: 5000 },
                prioridadeId: { required: true },
                protocoloCross: { required: this.additionals.obrigaPreenchimentoCross, max: 10 },
                reguladorId: { required: true },
                unidadeReguladoraId: { required: true },
                unidadeSolicitanteId: { required: true },
                usuarioSolicitante: { required: true },
                unidadeUsuarioId: { required: true },
                infraestruturaUsuarioId: { required: true },
                ocupacaoUsuarioId: { required: true },
            }
        },
        fields() {
            return {
                autocomplete: {
                    cid: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                    ciap: [
                        { key: 'codigo', searchable: true },
                        { key: 'descricao', searchable: true },
                    ],
                    usuarioSolicitante: [
                        { key: 'cadastro_cidadao.nome', searchable: true },
                    ],
                },
                procedimento: [
                    {
                        key: 'codigo',
                        label: 'Código',
                        sortable: true,
                        class: 'col-1',
                    },
                    {
                        key: 'nome',
                        label: 'Nome',
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        label: 'Ações',
                        class: 'col-1 text-center',
                    },
                ],
                historicoMovimentacoesStatus: [
                    { key: 'statusNome', label: 'Status', sortable: true },
                    { key: 'prestadorDescricao', label: 'Prestador', sortable: true },
                    {
                        key: 'dataAgendada',
                        label: 'Data agendada',
                        sortable: true,
                        formatter: v => v ? this.formatDate(v) : null,
                        filterByFormatted: true,
                    },
                    { key: 'horaAgendada', label: 'Hora agendada', sortable: true },
                    { key: 'opcaoRetiradaProtocoloAgendamentoNome', label: 'Status do protocolo', sortable: true },
                    { key: 'nomePessoaRetiradaProtocoloAgendamento', label: 'Protocolo retirado por', sortable: true },
                    {
                        key: 'dataHoraMovimentacao',
                        label: 'Data/hora da movimentação',
                        sortable: true,
                        formatter: v => this.formatDateTime(v),
                        filterByFormatted: true,
                    },
                    { key: 'usuarioQueMovimentou', label: 'Usuário que atualizou', sortable: true },
                    { key: 'justificativaStatus', label: 'Justificativa', sortable: true },
                ],
            }
        },
         checkBottonExame() {

            if (this.procedimento.length === 0 && (!this.model.infraestruturaSolicitanteId || !this.model.reguladorId)) {

                return true;
            } else if (this.procedimento.length > 0) {

                return this.origem === this.enums.origem.EXAME ? false : true;
            }
            return false;
        },
        checkBottonProcedimentoCirurgico() {

            if (this.procedimento.length === 0 && (!this.model.infraestruturaSolicitanteId || !this.model.reguladorId)) {

                return true;
            } else if (this.procedimento.length > 0) {

                return this.origem === this.enums.origem.PROCEDIMENTO_CIRURGICO ? false : true;
            }
            return false;
        },
        checkBottonEspecialidade() {

            if (this.procedimento.length === 0 && (!this.model.infraestruturaSolicitanteId || !this.model.reguladorId)) {

                return true;
            } else if (this.procedimento.length > 0) {

                return this.origem === this.enums.origem.ESPECIALIDADE ? false : true;
            }
            return false;
        },
        checkIsVisualizacao() {

            return this.isVisualizacao;
        },
    },
    created() {

        this.repositories = {
            ciap: this.getConectaSusRepository('geral.ciap'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            impressao: this.getConectaSusRepository('impressao.regulacao'),
            solicitacao: this.getConectaSusRepository('regulacao.solicitacao'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            upload: this.getConectaSusRepository('regulacao.upload'),
        }

        this.load()
    },
    data: () => ({
        alturaApi: false,
        enums: {
            origem,
            racaCor,
            sexo,
            tipoRegistro,
            classificacaoPaciente,
        },
        form: {},
        isDataLoaded: false,
        isEdicao : false,
        masks: {
            peso: '###.##',
            altura: '###',
        },
        model: {},
        additionals: {},
        dataSolicitacaoAtual: null,
        origem: null,
        pesoApi: false,
        procedimento: [],
        sexoPacienteId: null,
        isCiapRequired: false,
        isSupervisor: false,
        exitOption: null,
        isFirstLoad: true,
        uploads: [],
        colorButtonArquivos: 'primary',
    }),
    filters: {
        formatCpf: filters.formatCpf,
        formatCns: filters.formatCns,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.$nextTick().then(() => {
                this.setLoading();

                const request = this.id
                    ? this.repositories.solicitacao.edit(this.id)
                    : this.repositories.solicitacao.create(this.pacienteId);

                request
                    .then(response => {

                        const data = response.data;

                        if (data.additionals.enderecoDesatualizadoBloqueado) {

                            this.showAlert(
                                'O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o cadastro para continuar.',
                                'Atenção'
                            )

                            this.$router.push({ name: 'regulacao-solicitacao-index' })

                            return
                        }

                        this.additionals = data.additionals;
                        this.model = data.model;
                        this.form = data.form;

                        if (this.id) {

                            this.isEdicao = true;
                            this.model.altura = this.model.altura ? this.model.altura : null;
                            this.model.peso = this.model.peso ? this.model.peso : null;

                            const tipo = this.model.itens[0].origem;

                            if (tipo === 'exame') {

                                this.origem = this.enums.origem.EXAME;
                            }
                            if (tipo === 'procedimento_cirurgico') {

                                this.origem = this.enums.origem.PROCEDIMENTO_CIRURGICO;
                            }
                            if (tipo === 'especialidade') {

                                this.origem = this.enums.origem.ESPECIALIDADE;
                            }

                            this.procedimento = this.model.itens;

                        }

                        this.isDataLoaded = true;
                        this.model.altura ? this.model.alturaApi = true : false;
                        this.model.peso ? this.model.pesoApi = true : false;
                        this.sexoPacienteId = this.form.paciente.sexo === 'MASCULINO' ? 'M' : 'F';
                        this.dataSolicitacaoAtual = this.additionals.dataAtual;

                        this.validateDocuments();

                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading());
            });
        },
        updateCiapRequired() {

            const isCiap = this.model.usuarioSolicitante?.registroTipoId === this.enums.tipoRegistro.COREN;

            this.model.ciap = null;
            this.model.cid = null;
            this.isCiapRequired = isCiap;
        },
        validateDocuments() {

            const messages = [];

            if (this.checkIsVisualizacao) {

                return;
            }

            if (this.additionals.cnsPacienteProvisorio) {

                messages.push('O CNS do paciente é provisório.');
            }
            if (!this.additionals.cnsPacienteValido) {

                messages.push('O CNS do paciente é inválido.');
            }
            if (!this.additionals.cpfPacienteValido) {

                messages.push('O CPF do paciente é inválido.');
            }

            if (messages.length > 0) {

                const text = messages.join('<br>');

                this.showWarningNotification(
                    text
                );
            }
        },
        handlePesoInput() {

            const length = this.model.peso.replace('.', '').length

            if (length <= 3) {

                this.masks.peso = '#.##'
            }
            else if (length <= 4) {

                this.masks.peso = '##.##'
            }
            else {

                this.masks.peso = '###.##'
            }
        },
        getFilter() {

            const filter = this.clone(this.model);
            return this.camelObjectKeysToSnakeRecursive(filter);
        },
        handleUnidadeSolicitante() {

            const filter = this.getFilter();
            const params = { listar: 'infraestruturas-solicitantes', ...filter };

            this.repositories.solicitacao.list(params)
                .then(response => {

                    let unidadeSolicitante = this.form.unidadesSolicitantes.find(unidade => unidade.id === this.model.unidadeSolicitanteId);

                    let lotacaoAtual = response.data.find(infraestrutuaLotacaoAtual => infraestrutuaLotacaoAtual.id === this.model.infraestruturaSolicitanteId);

                    if (this.form.paciente.clissificacaoId !== this.enums.classificacaoPaciente.OUTRO_MUNICIPIO
                        || unidadeSolicitante.atendeOutroMunicipio)
                    {

                        this.form.infraestruturasSolicitantes = response.data;
                        this.model.infraestruturaSolicitanteId = lotacaoAtual ? lotacaoAtual.id : response.data[0]?.id;
                        this.handleInfraestruturaSolicitante();
                    }
                })
                .catch(this.handleError);
        },
        handleInfraestruturaSolicitante() {

                const filter = this.getFilter();
                const params = { listar: 'unidades-reguladoras', ...filter };

                this.repositories.solicitacao.list(params)
                    .then(response => {
                        this.form.unidadesReguladoras = response.data;

                        if (!this.id) {

                            this.model.unidadeReguladoraId = null;
                        }

                        if (this.form.paciente.clissificacaoId !== this.enums.classificacaoPaciente.OUTRO_MUNICIPIO) {

                            if (this.form.unidadesReguladoras.length === 1) {

                                this.model.unidadeReguladoraId = this.form.unidadesReguladoras[0].id;
                            }

                            this.handleUnidadeReguladora();
                        } else {

                            this.model.unidadeReguladoraId = null;
                        }
                    })
                    .catch(this.handleError);
        },
        handleUnidadeReguladora() {

            const filter = this.getFilter();
            const params = { listar: 'reguladores', ...filter };

            this.repositories.solicitacao.list(params)
                .then(response => {
                    this.form.reguladores = response.data;

                    if (this.model.unidadeReguladoraId !== null) {

                        this.model.reguladorId = response.data[0].id;
                    } else {

                        this.model.reguladorId = null;
                    }

                    if (this.form.reguladores.length === 1) {

                        this.model.reguladorId = this.form.reguladores[0].id;
                    }

                })
                .catch(this.handleError);
        },
        addExame(exames) {

            this.origem = this.enums.origem.EXAME
            this.procedimento = exames;
            this.model.itens = this.procedimento;
        },
        addEspecialidade(especialidades) {

            this.origem = this.enums.origem.ESPECIALIDADE
            this.procedimento = especialidades;
            this.model.itens = this.procedimento;
        },
        addProcedimento(procedimentos) {

            this.origem = this.enums.origem.PROCEDIMENTO_CIRURGICO
            this.procedimento = procedimentos;
            this.model.itens = this.procedimento;
        },
        addInfoUsuario(info) {

            this.model.infoProfissional = info;
        },
        destroy(item) {

            this.procedimento.splice(this.procedimento.indexOf(item), 1)
        },
        reloadPaciente(paciente) {

            const racaCorMap = {
                [this.enums.racaCor.BRANCA]: 'BRANCA',
                [this.enums.racaCor.NEGRA]: 'PRETA',
                [this.enums.racaCor.AMARELA]: 'PARDA',
                [this.enums.racaCor.PARDA]: 'AMARELA',
                [this.enums.racaCor.INDIGENA]: 'INDIGINA',
                [this.enums.racaCor.SEM_INFORMACAO]: 'SEM INFORMAÇÃO'
            };

            this.$set(this.form.paciente, 'telefones' , paciente.cidadao.telefones);
            this.form.paciente.cns = filters.formatCns(paciente.cidadao.cns);
            this.form.paciente.cpf = filters.formatCpf(paciente.cidadao.cpf);
            this.form.paciente.dataNascimento = moment(paciente.cidadao.dataNascimento).format('DD/MM/YYYY');
            this.form.paciente.endereco = paciente.cidadao.domicilio.endereco.completo;
            this.form.paciente.nome = paciente.cidadao.nome;
            this.form.paciente.nomeMae = paciente.cidadao.nomeMae;
            this.form.paciente.nomeSocial = paciente.cidadao.nomeSocial;
            this.form.paciente.protuario = paciente.prontuario;
            this.form.paciente.racaCor = racaCorMap[paciente.cidadao.racaCorId];
            this.form.paciente.rg = paciente.cidadao.rg;
            this.form.paciente.sexo = paciente.cidadao.sexo.descricao;

        },
        getItens() {

            const itens = [];

            if (this.origem === this.enums.origem.EXAME) {

                if (this.isEdicao) {

                    this.procedimento.map(procedimento => {
                        itens.push({
                            exame_id: procedimento.exameId ?? null,
                            origem: 'exame',
                            id: procedimento.id ?? null,
                        });
                    });
                } else {

                    this.procedimento.map(procedimento => {
                        itens.push({
                            exame_id: procedimento.id,
                            origem: 'exame',
                        });
                    });
                }
            }
            if (this.origem === this.enums.origem.PROCEDIMENTO_CIRURGICO) {

                if (this.isEdicao) {

                    this.procedimento.map(procedimento => {
                        itens.push({
                            procedimento_cirurgico_id: procedimento.procedimentoCirurgicoId ?? null,
                            origem: 'procedimento_cirurgico',
                            id: procedimento.id ?? null,
                        });
                    });
                } else {

                    this.procedimento.map(procedimento => {
                        itens.push({
                            procedimento_cirurgico_id: procedimento.id,
                            origem: 'procedimento_cirurgico',
                        });
                    });
                }
            }
            if (this.origem === this.enums.origem.ESPECIALIDADE) {

                if (this.isEdicao) {

                    this.procedimento.map(procedimento => {
                        itens.push({
                            especialidade_id: procedimento.especialidadeId ?? null,
                            origem: 'especialidade',
                            id: procedimento.id ?? null,
                        });
                    });
                } else {

                    this.procedimento.map(procedimento => {
                        itens.push({
                            especialidade_id: procedimento.id,
                            origem: 'especialidade',
                        });
                    });
                }
            }

            return itens;
        },
        getRequest() {

            let request = {}

            if (this.isEdicao) {

                const ocupacaoSelecionada = this.form.infoProfissional.ocupacoes.find(ocupacao => ocupacao.id === this.model.infoProfissional.ocupacaoUsuarioId);

                request = {
                    altura: this.model.altura ?? null,
                    ciapId: this.model.ciap ? this.model.ciap.id : null,
                    cidId: this.model.cid ? this.model.cid.id : null,
                    confirmado: true,
                    dataDesejada: this.model.dataDesejada,
                    dataSolicitacao: this.formattedDataAtual,
                    hipoteseDiagnosticaJustificativa: this.model.hipoteseDiagnosticaJustificativa ?? null,
                    isSupervisor: this.isSupervisor ?? false,
                    itens: this.getItens(),
                    observacao: this.model.observacao ?? null,
                    pacienteId: this.pacienteId,
                    peso: this.model.peso ?? null,
                    prioridadeId: this.model.prioridadeId,
                    protocoloCross: this.form.paciente.protocoloCross ?? null,
                    usuarioSolicitanteId: this.model.usuarioSolicitante.id,
                    unidadeUsuarioId:  this.model.infoProfissional?.unidadeUsuarioId ?? null,
                    infraestruturaUsuarioId: this.model.infoProfissional?.infraestruturaUsuarioId ?? null,
                    ocupacaoUsuarioId: this.model.infoProfissional?.ocupacaoUsuarioId ?? null,
                    lotacaoUsuarioId:  ocupacaoSelecionada ? ocupacaoSelecionada.lotacaoId : null,
                    usuarioSolicitanteEspecialidadeId: this.model.infoProfissional?.usuarioSolicitanteEspecialidadeId ?? null,
                }
            } else {

                const ocupacaoSelecionada = this.form.infoProfissional.ocupacoes.find(ocupacao => ocupacao.id === this.model.infoProfissional.ocupacaoUsuarioId);

                request = {
                    altura: this.model.altura ?? null,
                    ciapId: this.model.ciap ? this.model.ciap.id : null,
                    cidId: this.model.cid ? this.model.cid.id : null,
                    dataDesejada: this.model.dataDesejada,
                    dataSolicitacao: this.formattedDataAtual,
                    hipoteseDiagnosticaJustificativa: this.model.hipoteseDiagnosticaJustificativa ?? null,
                    infraestruturaSolicitanteId: this.model.infraestruturaSolicitanteId,
                    isSupervisor: this.isSupervisor ?? false,
                    itens: this.getItens(),
                    numero: this.model.numero.toString(),
                    observacao: this.model.observacao ?? null,
                    pacienteId: this.pacienteId,
                    peso: this.model.peso ?? null,
                    prioridadeId: this.model.prioridadeId,
                    protocoloCross: this.form.paciente.protocoloCross ?? null,
                    reguladorId: this.model.reguladorId,
                    usuarioSolicitanteId: this.model.usuarioSolicitante.id,
                    unidadeUsuarioId:  this.model.infoProfissional?.unidadeUsuarioId ?? null,
                    infraestruturaUsuarioId: this.model.infoProfissional?.infraestruturaUsuarioId ?? null,
                    ocupacaoUsuarioId: this.model.infoProfissional?.ocupacaoUsuarioId ?? null,
                    lotacaoUsuarioId:  ocupacaoSelecionada ? ocupacaoSelecionada.lotacaoId : null,
                    usuarioSolicitanteEspecialidadeId: this.model.infoProfissional?.usuarioSolicitanteEspecialidadeId ?? null,
                }
            }

            return request;
        },
        async print(id) {

            await new Promise(resolve => {
                this.unsetLoading();
                this.showConfirmation(
                    'Deseja imprimir a solicitação?',
                    async () => {
                        await this.confirmPrint(id);
                        resolve();
                    },
                    async () => {
                        resolve();
                    }
                );
            });
        },
        confirmPrint(id) {

            this.setLoading();

            this.repositories.impressao.solicitacaoRegulacao(id)
            .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        async saveExit() {

            this.$refs.Form.validate()
                .then(async valid => {

                    if (!valid) return;

                    if (this.procedimento.length === 0) {

                        this.showValidationNotification('Adicione ao menos um procedimento.');
                        return;
                    }

                    if (!this.checkHabilitaArquivo() && !this.isEdicao && this.uploads.length === 0) {

                        this.showWarningNotification(`O procedimento solicitado exige que sejam anexados documentos, por favor, anexe os arquivos necessários para que possa dar continuidade a sua solicitação.`);
                        this.colorButtonArquivos = 'primary';
                        this.$nextTick(() => {
                            this.$refs.buttonArquivos.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        });
                        return;
                    } else {
                        this.colorButtonArquivos = 'primary';
                    }

                    const request = this.getRequest();

                    this.setLoading()

                    try {
                        const response = this.isEdicao ?
                            await this.repositories.solicitacao.update(this.id, this.camelObjectKeysToSnakeRecursive(request)):
                            await this.repositories.solicitacao.store(this.camelObjectKeysToSnakeRecursive(request));

                            if (response && this.uploads.length > 0) {

                                const promises = []

                                this.uploads.forEach(upload => {
                                    let formData = new FormData()

                                    formData.append('solicitacao_id', response.data.id)
                                    formData.append('multiple', false)
                                    formData.append('upload[]', upload.file, upload.file.name)

                                    promises.push(() => this.repositories.upload.store(formData))
                                })

                                await Promise.all(promises.map(p => p()))
                            }

                            await this.print(response.data.id);

                        this.showSaveNotification();
                        this.isSupervisor = false;
                        this.uploads = [];
                        this.$emit('saveExit', response);
                    } catch (error) {

                        this.unsetLoading();

                        if (!error.response.data.itens || error.response.data.itens.length === 0 && error) {

                            this.handleError(error);
                        } else {

                            await new Promise(resolve => {
                                this.showConfirmation(
                                    error.response.data.message,
                                    async () => {
                                        await this.$refs.ModalSupervisor.open();
                                        this.exitOption = 'saveExit';
                                        resolve();
                                    },
                                    async () => {
                                        this.$emit('saveExit', null);
                                        this.exitOption = null;
                                        resolve();
                                    }
                                );
                            });
                        }
                    }
                });
        },
        async saveContinue() {

            this.$refs.Form.validate()
                .then(async valid => {

                    if (!valid)  return;

                    if (this.procedimento.length === 0) {

                        this.showValidationNotification('Adicione ao menos um procedimento.');
                        return;
                    }

                    if (!this.checkHabilitaArquivo() && !this.isEdicao && this.uploads.length === 0) {

                        this.showWarningNotification(`O procedimento solicitado exige que sejam anexados documentos. Por favor, anexe os arquivos necessários para dar continuidade à sua solicitação.`);
                        this.colorButtonArquivos = 'danger';
                        this.$nextTick(() => {
                            this.$refs.buttonArquivos.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        });
                        return;
                    } else {
                        this.colorButtonArquivos = 'primary';
                    }

                    const request = this.getRequest();

                    this.setLoading();

                    try {
                        const response = await this.repositories.solicitacao.store(this.camelObjectKeysToSnakeRecursive(request));

                        if (response && this.uploads.length > 0) {

                            const promises = []

                            this.uploads.forEach(upload => {
                                let formData = new FormData()

                                formData.append('solicitacao_id', response.data.id)
                                formData.append('multiple', false)
                                formData.append('upload[]', upload.file, upload.file.name)

                                promises.push(() => this.repositories.upload.store(formData))
                            })

                            await Promise.all(promises.map(p => p()))
                        }

                        const createNew = await this.repositories.solicitacao.create(this.pacienteId);

                        await this.print(response.data.id);

                        this.$emit('saveContinue', response);
                        this.procedimento = [];
                        this.uploads = [];
                        this.model.numero = createNew.data.model.numero;
                        this.isSupervisor = false;
                        this.$nextTick().then(() => this.$refs.Form.resetValidator())
                    } catch (error) {

                        this.unsetLoading();

                        if (!error.response.data.itens || error.response.data.itens.length === 0 && error) {

                            this.handleError(error);
                        } else {

                            await new Promise(resolve => {
                                this.showConfirmation(
                                    error.response.data.message,
                                    async () => {
                                        await this.$refs.ModalSupervisor.open();
                                        this.exitOption = 'saveContinue';
                                        resolve();
                                    },
                                    async () => {
                                        this.procedimento = [];
                                        this.$nextTick().then(() => this.$refs.Form.resetValidator())
                                        this.$emit('saveContinue', null);
                                        this.exitOption = null;
                                        this.uploads = [];
                                        resolve();
                                    }
                                );
                            });
                        }
                    }
                })
        },
        authorized(value) {

            this.isSupervisor = value;
            if (this.exitOption === 'saveExit') this.saveExit();
            if (this.exitOption === 'saveContinue') this.saveContinue();
            this.exitOption = null;
        },
        canceled() {

            this.isSupervisor = false;
            this.exitOption = null;
        },
        handleProfissionalSolicitanteChange() {

            this.repositories.solicitacao.getInfoProfissional({usuario_id: this.model.usuarioSolicitante.id, listar: 'unidades'})
                .then(response => {

                    const data = response.data;

                    this.form.infoProfissional = data.form.infoProfissional;

                    if (this.form.infoProfissional.unidades.length === 1) {

                        this.model.infoProfissional.unidadeId = this.form.infoProfissional.unidades[0].id;
                        this.handleUnidadeUsuarioSolitante();
                    }
                })
                .catch(this.handleError);
        },
        handleUnidadeUsuarioSolitante() {

            this.model.infoProfissional.infraestruturaUsuarioId = null,
            this.model.infoProfissional.lotacaoUsuarioId = null,
            this.model.infoProfissional.ocupacaoUsuarioId = null

            this.form.infoProfissional.especialidades = []
            this.model.infoProfissional.usuarioSolicitanteEspecialidadeId = null

            this.repositories.solicitacao.getInfoProfissional({
                usuario_id: this.model.usuarioSolicitante.id,
                listar: 'infraestruturas',
                unidade_id: this.model.infoProfissional.unidadeUsuarioId
            })
                .then(response => {

                    const data = response.data;
                    this.form.infoProfissional.infraestruturas = data.form.infoProfissional.infraestruturas;

                    if (this.form.infoProfissional.infraestruturas.length === 1) {

                        this.model.infoProfissional.infraestruturaUsuarioId = this.form.infoProfissional.infraestruturas[0].id;
                        this.handleInfraestruturaUsuarioSolitante();
                    }
                })
                .catch(this.handleError);
        },
        handleInfraestruturaUsuarioSolitante() {

                this.model.infoProfissional.lotacaoUsuarioId = null,
                this.model.infoProfissional.ocupacaoUsuarioId = null

                this.form.infoProfissional.especialidades = []
                this.model.infoProfissional.usuarioSolicitanteEspecialidadeId = null

                this.repositories.solicitacao.getInfoProfissional({
                    usuario_id: this.model.usuarioSolicitante.id,
                    listar: 'ocupacoes',
                    infraestrutura_id: this.model.infoProfissional.infraestruturaUsuarioId
                })
                    .then(response => {

                        const data = response.data;

                        this.form.infoProfissional.ocupacoes = data.form.infoProfissional.ocupacoes;

                        if (this.form.infoProfissional.ocupacoes.length === 1) {

                            this.model.infoProfissional.ocupacaoUsuarioId = this.form.infoProfissional.ocupacoes[0].id;
                            this.handleOcupacaoUsuarioSolitante()
                        }
                    })
                    .catch(this.handleError);
        },
        handleOcupacaoUsuarioSolitante() {

                this.form.infoProfissional.especialidades = []
                this.model.infoProfissional.usuarioSolicitanteEspecialidadeId = null

                this.repositories.solicitacao.getInfoProfissional({
                    listar: 'especialidades',
                    ocupacao_id: this.model.infoProfissional.ocupacaoUsuarioId
                })
                    .then(response => {

                        const data = response.data;

                        this.form.infoProfissional.especialidades = data.form.infoProfissional.especialidades;

                        if (this.form.infoProfissional.especialidades.length === 1) {

                            this.model.infoProfissional.usuarioSolicitanteEspecialidadeId = this.form.infoProfissional.especialidades[0].id;
                        }
                    })
                    .catch(this.handleError);
        },
        hasPermissao(hash) {
            return this.verificarPermissao(hash);
        },
        checkHabilitaArquivo() {
            if (this.model.itens.length === 0) {
                return true;
            } else if (this.isEdicao) {
                return false;
            } else {
                return !this.model.itens.some(item => item.exigeDocumentoAnexo) ? true : false;
            }
        },
        printHistoricoMovimentacoes() {

            this.setLoading()

            this.repositories.impressao.historicoMovimentacaoSolicitacao(this.id)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, stringCase, object, error, formats, file, permissao],
    props: {
        id: { type: Number, default: null },
        pacienteId: { type: Number, default: null, required: true },
        isVisualizacao: { type: Boolean, default: false },
    },
    watch: {
        'model.unidadeSolicitanteId'() {
            this.handleUnidadeSolicitante()
        },
        'model.infraestruturaSolicitanteId'() {
            this.handleInfraestruturaSolicitante()
        },
        'model.unidadeReguladoraId'() {
            this.handleUnidadeReguladora()
        },
        'model.usuarioSolicitante.registroTipoId': 'updateCiapRequired',
        'model.itens': 'checkHabilitaArquivo',
    },
}
</script>
<style scoped>
    .table-procedimento {
        margin-top: 20px;
    }
    .telefones {
        margin-top: 10px;
    }
    .endereco {
        margin-top: 5px;
    }
    .buttons {
        margin-top: 10px;
    }
</style>